import {useState} from 'react';
import moment from 'moment';

import CandidateDetailsModal from './CandidateDetailsModal';
import RejectedCandidateModal from './RejectedCandidateModal';

import expEnum from '../../pages/JobDetails';

const CardDetails = ({name, exp, time}) => (
  <>
    <img
      className="inline-block h-14 w-14 rounded-full ring-2 ring-white"
      src="https://images.unsplash.com/photo-1550525811-e5869dd03032?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
      alt=""
      onDragStart={(e) => e.preventDefault()}
    />
    <div className="flex flex-col justify-center">
      <div className="text-sm font-medium">{name}</div>
      <div className="text-xs font-medium">{expEnum[exp] || exp}</div>
      <div className="text-xs font-medium text-[#8C8C8C]">
        {moment(time).fromNow()}
      </div>
    </div>
  </>
);

const CandidateCard = ({
  name,
  exp,
  time,
  skill,
  designation,
  currentCTC,
  expectedCTC,
  rejectedReason,
  declinedReason,
  isDeclined,
  onDragStart,
  onDragEnter,
  dropable = true,
}) => {
  const [detailModal, setDetailModal] = useState(false);

  if (dropable) {
    return (
      <>
        <div
          className="border-rounded mb-2 flex h-[90px] min-w-[260px] cursor-grab select-none space-x-4 bg-white p-4"
          draggable={dropable}
          onDragEnter={onDragEnter}
          onDragStart={onDragStart}
          onClick={() => setDetailModal(true)}
        >
          <CardDetails name={name} exp={exp} time={time} />
        </div>

        {/* Candidate Details Modal */}
        {detailModal && (
          <CandidateDetailsModal
            isOpen={detailModal}
            onClose={() => setDetailModal(false)}
            name={name}
            exp={exp}
            skill={skill}
            designation={designation}
            currentCTC={currentCTC}
            expectedCTC={expectedCTC}
            title="Candidate details"
          />
        )}
      </>
    );
  }

  return (
    <>
      <div
        className="border-rounded mb-2 flex h-[90px] min-w-[260px] cursor-no-drop select-none space-x-4 bg-white
        p-4"
        onClick={() => setDetailModal(true)}
      >
        <CardDetails name={name} exp={exp} time={time} />
      </div>

      {/* Rejected Candidate Details Modal */}
      {detailModal && (
        <RejectedCandidateModal
          isOpen={detailModal}
          onClose={() => setDetailModal(false)}
          name={name}
          exp={exp}
          reason={rejectedReason || declinedReason}
          text={isDeclined ? 'declination' : 'rejection'}
          title="Candidate details"
        />
      )}
    </>
  );
};

export default CandidateCard;
